import { render } from "./InlineAlert.vue?vue&type=template&id=4cf2324d&scoped=true"
import script from "./InlineAlert.vue?vue&type=script&lang=js"
export * from "./InlineAlert.vue?vue&type=script&lang=js"

import "./InlineAlert.vue?vue&type=style&index=0&id=4cf2324d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf2324d"]])

export default __exports__